import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { FilterDropdown } from "/imports/ui/components/shared";
import { FilterChip, OptionRow } from "/imports/ui/components/booking";

function EventFilters({ defs }) {
  const [activeKey, setActiveKey] = useState(null);

  const shown = defs.filter((d) => d.options.length > 1 || d.value != null);
  if (shown.length === 0) return null;

  const activeDef = shown.find((d) => d.key === activeKey);
  const closeSheet = () => setActiveKey(null);
  const pick = (def, value) => {
    def.onChange(value);
    closeSheet();
  };

  return (
    <>
      <Box sx={{ display: { xs: "grid", md: "none" }, gridTemplateColumns: shown.length > 1 ? "1fr 1fr" : "1fr", gap: 1, mb: 2 }}>
        {shown.map((d, i) => (
          <Box key={d.key} sx={{ gridColumn: shown.length % 2 === 1 && i === shown.length - 1 ? "1 / -1" : "auto" }}>
            <FilterChip
              label={d.label}
              value={d.options.find((o) => o.value === d.value)?.label || "All"}
              active={d.value != null}
              onClick={() => setActiveKey(d.key)}
            />
          </Box>
        ))}
      </Box>

      <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1.5, flexWrap: "wrap", mb: 2 }}>
        {shown.map((d) => (
          <FilterDropdown
            key={d.key}
            label={d.label}
            options={d.options}
            value={d.value}
            onChange={d.onChange}
            allLabel={d.allLabel}
            active={d.value != null}
          />
        ))}
      </Box>

      <Drawer
        anchor="bottom"
        open={!!activeDef}
        onClose={closeSheet}
        PaperProps={{ sx: { borderTopLeftRadius: 20, borderTopRightRadius: 20, maxHeight: "75vh", px: 2.5, pt: 2, pb: 3 } }}
      >
        <Box sx={{ width: "2.5rem", height: "0.25rem", borderRadius: 2, bgcolor: "divider", mx: "auto", mb: 2 }} />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Typography sx={{ fontSize: "1.05rem", fontWeight: 700 }}>{activeDef?.label || ""}</Typography>
          <IconButton size="small" onClick={closeSheet} aria-label="Close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, overflowY: "auto" }}>
          {activeDef && (
            <>
              <OptionRow label={activeDef.allLabel} selected={activeDef.value == null} onClick={() => pick(activeDef, null)} />
              {activeDef.options.map((opt) => (
                <OptionRow
                  key={opt.value}
                  label={opt.label}
                  sublabel={opt.sublabel}
                  selected={activeDef.value === opt.value}
                  onClick={() => pick(activeDef, opt.value)}
                />
              ))}
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
}

export default EventFilters;
